import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'groups',
  initialState: {
    items: {},
  },
  reducers: {
    refresh(state, action) {
      state.items = {};
      action.payload.forEach((item) => state.items[item.id] = item);
    },
    // 2ECOMP: PremiumUI Refresh — inline group CRUD
    update(state, action) {
      const items = Array.isArray(action.payload) ? action.payload : [action.payload];
      items.forEach((item) => state.items[item.id] = item);
    },
    remove(state, action) {
      delete state.items[action.payload];
    },
  },
});

export { actions as groupsActions };
export { reducer as groupsReducer };
